module.exports = __webpack_public_path__ + "media/de_de_s2_Knut.a1a69560.mp3";